<template>
    <div class="collaborator" :class="{ 'active': expandCollaborator == collaborator.name }">
        <div
            class="close-bio"
            :class="{ 'show' : expandCollaborator == collaborator.name}"
            @click.stop="$emit('close-bio')"
        >
            <img src="@assets/img/x-gray.svg" alt="Close bio">
        </div>
        <figure>
            <img v-lazy="collaborator.picture" :alt="`${ collaborator.name } Picture`">
        </figure>
        <h3 class="text-truncate">
            {{ collaborator.name }}
        </h3>
        <p>{{ collaborator.bio }}</p>
        <span class="text-primary">Show Bio</span>
    </div>
</template>

<script>
export default {
    name: "CollaboratorBio",
    props: {
        collaborator: {
            type: Object,
            required: true
        },
        expandCollaborator: {
            type: String,
            default: ""
        }
    }
}
</script>

<style lang="scss">
.collaborator {
    background-color: $dark-gray;
    box-shadow: 0 0 0 0 rgba(0, 0, 0,0);
    transition: all .3s ease-in;
    padding: 40px 30px 20px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    margin-bottom: 30px;
    position: relative;
    cursor: pointer;

    @media (max-width: $lg) {
        padding: 40px 20px 20px 20px;
    }

    .close-bio {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 20px;
        top: 20px;
        opacity: 0;
        transition: opacity .3s ease-in;

        img {
            width: 18px;
        }

        &.show {
            opacity: .7;
        }
    }

    figure {
        width: 140px;
        height: 140px;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
        margin-bottom: 40px;
        flex-shrink: 0;

        img {
            width: 140px;
            height: 140px;
            object-fit: cover;
        }
    }

    h3 {
        font-size: 23px;
        font-weight: 600;
        margin-bottom: 15px;
        color: white;
    }

    p {
        font-size: 15px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.53;
        letter-spacing: 0.4px;
        text-align: center;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-bottom: 0;
        margin-bottom: 20px;
        max-height: 66px;
        transition: max-height .5s ease-in;
        color: white;
    }

    &.active {
        z-index: 3;
        background-color: $medium-gray;
        box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.18);

        @media (min-width: $sm-tablet-v) {
            position: absolute;
            width: calc(100% - 30px);
        }

        p {
            -webkit-line-clamp: initial;
            max-height: 500px;
        }

        span {
            display: none;
        }
    }
}
</style>
